//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.PhysicsJointBuilder.js";
import "../Mechatronics/Mechatronics.PathConstraintFrameBuilderList.js";
import "../no/ObjectList.js";
let d=[[[0,"AxisVector",1,"Direction",0],[1,"FrameList",0,"Mechatronics.PathConstraintFrameBuilderList",0],[0,"PathPreview",1,0],[0,"PathType",1,0],[0,"PointOnCurve",1,"Point",0]],[[["numCurves"],"GetPathCurves",{R_:{pathCurves:"NXObject[]"}},0,0],[["pathCurves"],"SetPathCurvesFromCurves",{},1,0],[["curves"],"EvaluatePath",{},1,0],[[],"NewPathFrame",{R_:{pathFrameBuilder:"Mechatronics.PathConstraintFrameBuilder"}},0,0],[[],"GeneratePathCurves",{},0,0]],[]];
SPLM.Mechatronics.PathConstraintJointBuilder = class extends SPLM.Mechatronics.PhysicsJointBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.PathConstraintJointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.PathConstraintJointBuilder.PathTypes = Object.freeze({
    "FromCoordinateSystems" : "FromCoordinateSystems", "FromCurves" : "FromCurves"});

export default SPLM;